const en = {
  brand_tag: "Autonomous · Compliant · Data Sovereignty · Decentralised · Democratic · Experiential · Personalised · Self-Evolving · Universally-Adaptive AI PaaS",
  nav_home: "Home", nav_engine: "Business", nav_interpret: "Interpreter", nav_personal: "Personal", nav_vault: "My Vault", nav_economy: "My Earnings",
  nav_insights: "Self-Evolution", nav_about: "The My Kind Story", nav_search: "Search", nav_community: "Community",
  login: "Log in", signup: "Sign up", logout: "Log out", get_started: "Get Started",
  hero_title: "GOD Mode for everything, every individual, industry, government, idea, challenge or transformation.",
  hero_universal: "A Universal, Self-Evolving AI PaaS.",
  hero_sub: "My Kind does everything for everyone — just ask. For individuals, it interprets receipts, medical reports, books, articles and social profiles & posts, and gives personalised, intelligent recommendations. For businesses, it architects compliance blueprints, builds software, strategy and consulting — removing every barrier to entry, in the language and geography you want.",
  hero_cta: "Enter the Engine", hero_cta2: "Meet My Kind — your AI assistant",
  hero_gen6: "The first of its kind 6th-Generation purpose and meaningful Global App — changing how we live, do business, and transforming the quality of our lives.",
  engine_title: "The Industry Engine",
  engine_sub: "Pick any industry, government department and country. My Kind instantly architects blueprints, builds experiential software, crafts marketing (logos, decks, PDFs, flyers, brochures, articles) and management-consulting plans, and gives insights and recommendations.",
  search_industries: "Search industries & sectors…",
  choose_region: "Choose region", generate_blueprint: "Generate Compliance Blueprint",
  solution_type: "Solution", economy_title: "The Autonomous Economy",
  referral_title: "Referral Program", about_title: "The Karm sanya Story",
  language: "Language", theme: "Theme", credits: "Credits",
};

const t = (o) => ({ ...en, ...o });

export const TRANSLATIONS = {
  en,
  hi: t({
    brand_tag: "विश्व-अनुकूल · स्व-विकसित PaaS",
    nav_home: "मुख्य", nav_engine: "उद्योग इंजन", nav_economy: "अर्थव्यवस्था",
    nav_insights: "स्व-विकास", nav_about: "परिचय",
    login: "लॉग इन", signup: "साइन अप", logout: "लॉग आउट", get_started: "शुरू करें",
    hero_title: "हर चीज़ के लिए गॉड मोड — हर व्यक्ति, उद्योग, सरकार, विचार, चुनौती या परिवर्तन के लिए।",
    hero_sub: "My Kind अनुपालन ब्लूप्रिंट बनाता है, सॉफ़्टवेयर तैयार करता है और हर बाधा हटाता है — आपकी भाषा में, आपके क्षेत्र के लिए।",
    hero_cta: "इंजन में प्रवेश करें", hero_cta2: "My Kind से मिलें",
    engine_title: "उद्योग इंजन", search_industries: "उद्योग व क्षेत्र खोजें…",
    choose_region: "क्षेत्र चुनें", generate_blueprint: "अनुपालन ब्लूप्रिंट बनाएं",
    language: "भाषा", theme: "थीम", credits: "क्रेडिट",
  }),
  es: t({
    brand_tag: "PaaS globalmente adaptable y auto-evolutivo",
    nav_home: "Inicio", nav_engine: "Motor de Industrias", nav_economy: "Economía",
    nav_insights: "Auto-Evolución", nav_about: "Acerca de",
    login: "Entrar", signup: "Registrarse", logout: "Salir", get_started: "Empezar",
    hero_title: "Modo Dios para todo: cada individuo, industria, gobierno, idea, desafío o transformación.",
    hero_sub: "My Kind diseña planos de cumplimiento, crea software y elimina toda barrera — en tu idioma, para tu región.",
    hero_cta: "Entrar al Motor", hero_cta2: "Conoce a My Kind",
    engine_title: "El Motor de Industrias", search_industries: "Buscar industrias y sectores…",
    choose_region: "Elegir región", generate_blueprint: "Generar Plano de Cumplimiento",
    language: "Idioma", theme: "Tema", credits: "Créditos",
  }),
  zh: t({
    brand_tag: "全球自适应 · 自我进化 PaaS",
    nav_home: "首页", nav_engine: "行业引擎", nav_economy: "经济",
    nav_insights: "自我进化", nav_about: "关于",
    login: "登录", signup: "注册", logout: "退出", get_started: "开始",
    hero_title: "为一切开启上帝模式——每个人、行业、政府、想法、挑战或变革。",
    hero_sub: "My Kind 构建合规蓝图、开发软件并消除一切进入壁垒——以您的语言，为您的地区。",
    hero_cta: "进入引擎", hero_cta2: "认识 My Kind",
    engine_title: "行业引擎", search_industries: "搜索行业与领域…",
    choose_region: "选择地区", generate_blueprint: "生成合规蓝图",
    language: "语言", theme: "主题", credits: "积分",
  }),
  ar: t({
    brand_tag: "منصة عالمية التكيّف ذاتية التطور",
    nav_home: "الرئيسية", nav_engine: "محرك الصناعات", nav_economy: "الاقتصاد",
    nav_insights: "التطور الذاتي", nav_about: "من نحن",
    login: "تسجيل الدخول", signup: "إنشاء حساب", logout: "خروج", get_started: "ابدأ الآن",
    hero_title: "وضع الإله لكل شيء — لكل فرد وصناعة وحكومة وفكرة وتحدٍّ أو تحوّل.",
    hero_sub: "يصمم My Kind مخططات الامتثال، ويبني البرمجيات، ويزيل كل الحواجز — بلغتك ولمنطقتك.",
    hero_cta: "ادخل المحرك", hero_cta2: "تعرّف على My Kind",
    engine_title: "محرك الصناعات", search_industries: "ابحث في الصناعات والقطاعات…",
    choose_region: "اختر المنطقة", generate_blueprint: "أنشئ مخطط الامتثال",
    language: "اللغة", theme: "المظهر", credits: "الأرصدة",
  }),
  fr: t({
    brand_tag: "PaaS mondial, adaptatif et auto-évolutif",
    nav_home: "Accueil", nav_engine: "Moteur d'Industries", nav_economy: "Économie",
    nav_insights: "Auto-Évolution", nav_about: "À propos",
    login: "Connexion", signup: "S'inscrire", logout: "Déconnexion", get_started: "Commencer",
    hero_title: "Mode Divin pour tout : chaque individu, industrie, gouvernement, idée, défi ou transformation.",
    hero_sub: "My Kind conçoit des plans de conformité, crée des logiciels et supprime toute barrière — dans votre langue, pour votre région.",
    hero_cta: "Entrer dans le Moteur", hero_cta2: "Rencontrer My Kind",
    engine_title: "Le Moteur d'Industries", search_industries: "Rechercher industries et secteurs…",
    choose_region: "Choisir la région", generate_blueprint: "Générer le Plan de Conformité",
    language: "Langue", theme: "Thème", credits: "Crédits",
  }),
  pt: t({
    brand_tag: "PaaS global, adaptável e auto-evolutivo",
    nav_home: "Início", nav_engine: "Motor de Indústrias", nav_economy: "Economia",
    nav_insights: "Auto-Evolução", nav_about: "Sobre",
    login: "Entrar", signup: "Cadastrar", logout: "Sair", get_started: "Começar",
    hero_title: "Modo Deus para tudo: cada indivíduo, indústria, governo, ideia, desafio ou transformação.",
    hero_sub: "A My Kind arquiteta planos de conformidade, cria software e remove todas as barreiras — no seu idioma, para sua região.",
    hero_cta: "Entrar no Motor", hero_cta2: "Conheça a My Kind",
    engine_title: "O Motor de Indústrias", search_industries: "Buscar indústrias e setores…",
    choose_region: "Escolher região", generate_blueprint: "Gerar Plano de Conformidade",
    language: "Idioma", theme: "Tema", credits: "Créditos",
  }),
  de: t({
    brand_tag: "Global anpassbare, sich selbst entwickelnde PaaS",
    nav_home: "Start", nav_engine: "Branchen-Engine", nav_economy: "Wirtschaft",
    nav_insights: "Selbst-Evolution", nav_about: "Über uns",
    login: "Anmelden", signup: "Registrieren", logout: "Abmelden", get_started: "Loslegen",
    hero_title: "God Mode für alles — jeden Menschen, jede Branche, Regierung, Idee, Herausforderung oder Transformation.",
    hero_sub: "My Kind entwirft Compliance-Blueprints, baut Software und beseitigt jede Hürde — in Ihrer Sprache, für Ihre Region.",
    hero_cta: "Engine betreten", hero_cta2: "My Kind treffen",
    engine_title: "Die Branchen-Engine", search_industries: "Branchen & Sektoren suchen…",
    choose_region: "Region wählen", generate_blueprint: "Compliance-Blueprint erstellen",
    language: "Sprache", theme: "Design", credits: "Guthaben",
  }),
  ja: t({
    brand_tag: "グローバル適応・自己進化型 PaaS",
    nav_home: "ホーム", nav_engine: "産業エンジン", nav_economy: "経済",
    nav_insights: "自己進化", nav_about: "私たちについて",
    login: "ログイン", signup: "登録", logout: "ログアウト", get_started: "始める",
    hero_title: "あらゆるもののためのゴッドモード — すべての個人、産業、政府、アイデア、課題、変革のために。",
    hero_sub: "My Kind はコンプライアンス設計図を構築し、ソフトウェアを作り、あらゆる参入障壁を取り除きます — あなたの言語で、あなたの地域のために。",
    hero_cta: "エンジンへ", hero_cta2: "My Kind に会う",
    engine_title: "産業エンジン", search_industries: "産業・分野を検索…",
    choose_region: "地域を選択", generate_blueprint: "コンプライアンス設計図を生成",
    language: "言語", theme: "テーマ", credits: "クレジット",
  }),
  ru: t({
    brand_tag: "Глобально адаптивная, само-развивающаяся PaaS",
    nav_home: "Главная", nav_engine: "Движок отраслей", nav_economy: "Экономика",
    nav_insights: "Само-эволюция", nav_about: "О нас",
    login: "Войти", signup: "Регистрация", logout: "Выйти", get_started: "Начать",
    hero_title: "Режим Бога для всего — каждого человека, отрасли, правительства, идеи, вызова или преобразования.",
    hero_sub: "My Kind проектирует чертежи соответствия, создаёт ПО и убирает все барьеры — на вашем языке, для вашего региона.",
    hero_cta: "Войти в движок", hero_cta2: "Познакомиться с My Kind",
    engine_title: "Движок отраслей", search_industries: "Поиск отраслей и секторов…",
    choose_region: "Выбрать регион", generate_blueprint: "Создать чертёж соответствия",
    language: "Язык", theme: "Тема", credits: "Кредиты",
  }),
};

export function getTranslator(lang) {
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
  return (key) => dict[key] || TRANSLATIONS.en[key] || key;
}
